// extracted by mini-css-extract-plugin
export default {"p_content":"f796351659"};